import { createIcon } from "@chakra-ui/react";

export const PdfIcon = createIcon({
  displayName: "PdfIcon",
  viewBox: "0 0 16 20",
  defaultProps: {
    width: "16",
    height: "20",
    fill: "none",
  },
  path: (
    <path d="M1 15V10H2.5C2.89782 10 3.27936 10.158 3.56066 10.4393C3.84196 10.7206 4 11.1022 4 11.5C4 11.8978 3.84196 12.2794 3.56066 12.5607C3.27936 12.842 2.89782 13 2.5 13H1M13 15V10H15M13 13H15M1 8V5.914C1.00006 5.64881 1.10545 5.39449 1.293 5.207L5.207 1.293C5.39449 1.10545 5.6488 1.00006 5.914 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289C14.8946 1.48043 15 1.73478 15 2V8M1 17V18C1 18.2652 1.10536 18.5196 1.29289 18.7071C1.48043 18.8946 1.73478 19 2 19H14C14.2652 19 14.5196 18.8946 14.7071 18.7071C14.8946 18.5196 15 18.2652 15 18V17M6 1V5C6 5.26522 5.89464 5.51957 5.70711 5.70711C5.51957 5.89464 5.26522 6 5 6H1M7 10V15H8.375C8.80581 14.9995 9.21883 14.8281 9.52346 14.5235C9.8281 14.2188 9.99947 13.8058 10 13.375V11.625C9.99947 11.1942 9.8281 10.7812 9.52346 10.4765C9.21883 10.1719 8.80581 10.0005 8.375 10H7Z" stroke="black" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
  ),
});
